import { useEffect, useState } from "react";
import { X, Megaphone, AlertTriangle, CheckCircle2 } from "lucide-react";
import { getActiveAnnouncements, announcementEvent } from "../api";
import { useAuth } from "../context/AuthContext";
import "./announcement-banner.css";

const ICON = { info: Megaphone, warning: AlertTriangle, success: CheckCircle2 };

export default function AnnouncementBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem("imperio_ann_dismissed") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    if (!user) { setItems([]); return; }
    getActiveAnnouncements().then((r) => {
      const list = r.announcements || [];
      setItems(list);
      // record a view once per session per announcement
      let seen = [];
      try { seen = JSON.parse(sessionStorage.getItem("imperio_ann_viewed") || "[]"); } catch { seen = []; }
      list.forEach((a) => {
        if (!seen.includes(a.id)) {
          announcementEvent(a.id, "view").catch(() => {});
          seen.push(a.id);
        }
      });
      sessionStorage.setItem("imperio_ann_viewed", JSON.stringify(seen));
    }).catch(() => setItems([]));
  }, [user]);

  const dismiss = (id) => {
    const next = [...new Set([...dismissed, id])];
    setDismissed(next);
    localStorage.setItem("imperio_ann_dismissed", JSON.stringify(next));
    announcementEvent(id, "dismiss").catch(() => {});
  };

  const visible = items.filter((a) => !dismissed.includes(a.id));
  if (!visible.length) return null;

  return (
    <div className="ann-stack" data-testid="announcement-banner">
      {visible.map((a) => {
        const Ico = ICON[a.level] || Megaphone;
        return (
          <div key={a.id} className={`ann-bar ann-${a.level}`} data-testid={`announcement-${a.id}`}>
            <Ico size={16} className="ann-ico" />
            <div className="ann-txt"><b>{a.title}</b>{a.body ? <span> — {a.body}</span> : null}</div>
            {a.dismissible !== false && (
              <button className="ann-x" data-testid={`announcement-dismiss-${a.id}`} onClick={() => dismiss(a.id)} aria-label="Dismiss"><X size={15} /></button>
            )}
          </div>
        );
      })}
    </div>
  );
}
